import { render, staticRenderFns } from "./BenefitsSectionCard.vue?vue&type=template&id=bd6d6db4&scoped=true"
import script from "./BenefitsSectionCard.vue?vue&type=script&lang=js"
export * from "./BenefitsSectionCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSectionCard.vue?vue&type=style&index=0&id=bd6d6db4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6d6db4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6d6db4')) {
      api.createRecord('bd6d6db4', component.options)
    } else {
      api.reload('bd6d6db4', component.options)
    }
    module.hot.accept("./BenefitsSectionCard.vue?vue&type=template&id=bd6d6db4&scoped=true", function () {
      api.rerender('bd6d6db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Benefit/BenefitsSectionCard.vue"
export default component.exports